module.exports = __webpack_public_path__ + "dacbb5a1927f6dcd2d9e3a246b26f477.jpg";


//////////////////
// WEBPACK FOOTER
// ./assets/imgs/media4.jpg
// module id = 192
// module chunks = 0